var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-shell-page"},[_c('BicyclePlugins',{key:'position',attrs:{"default-vehicle-mode":"single"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }